import { Link, useLocation } from 'react-router-dom';
import { Menu, ShieldCheck, Heart, BookOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetTrigger, SheetContent } from '@/components/ui/sheet';
import { useState } from 'react';

const navLinks = [
  { to: '/', label: 'Accueil', id: 'accueil' },
  { to: '/catalogue', label: 'Catalogue', id: 'catalogue' },
  { to: '/series', label: 'Séries', id: 'series', icon: BookOpen },
  { to: '/wishlist', label: 'Mes suivis', id: 'wishlist', icon: Heart },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200/60" data-testid="navbar">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl flex items-center justify-between h-20 md:h-24">
        <Link to="/" className="flex items-center group" data-testid="navbar-logo">
          <img src="/logo-header.png" alt="Plume et Pion - BD, Jeunesse, Mangas, Jeux de société" className="h-16 md:h-20 w-auto transition-transform group-hover:scale-[1.03]" data-testid="navbar-logo-img" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors ${location.pathname === link.to ? 'text-violet-600' : 'text-slate-600 hover:text-violet-600'}`}
              data-testid={`nav-link-${link.id}`}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/admin/login" data-testid="nav-admin-link">
            <Button variant="ghost" size="sm" className="text-slate-400 hover:text-violet-600 gap-1.5">
              <ShieldCheck className="h-4 w-4" />
              Admin
            </Button>
          </Link>
        </nav>

        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" data-testid="mobile-menu-btn">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-64">
              <div className="mt-8 flex flex-col gap-4">
                {navLinks.map(link => (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={() => setOpen(false)}
                    className={`text-lg font-medium px-4 py-2 rounded-lg ${location.pathname === link.to ? 'bg-violet-50 text-violet-600' : 'text-slate-700'}`}
                  >
                    {link.label}
                  </Link>
                ))}
                <Link to="/admin/login" onClick={() => setOpen(false)} className="text-sm text-slate-400 px-4 py-2 mt-4">
                  Administration
                </Link>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
